module.exports = global["$"] = require("-!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?$!./node_modules/jquery/dist/jquery.js
// module id = bgjk
// module chunks = 25